// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__iuUqE","currentUser":"SideBar_currentUser__Vtyw4","navLinks":"SideBar_navLinks__hTWzJ","linkBtn":"SideBar_linkBtn__sWoRA","blue":"SideBar_blue__RVW1H"};